(() => {
  const ROOT = '[data-ai-swatches]';

  const selectFirst = (root) => {
    if (!root || root.querySelector('.ai-color-swatch.selected')) return;
    const first = root.querySelector('.ai-color-swatch');
    if (first) {
      first.classList.add('selected');
      syncValue(root, first.getAttribute('data-color') || '');
    }
  };

  const findForm = (root) => {
    return (
      root.closest('form') ||
      (root.closest('product-form, quick-add-modal, .quick-add-modal, .modal, .drawer, .popup, body')
        ?.querySelector('form[action*="/cart/add"]')) ||
      null
    );
  };

  const syncValue = (root, color) => {
    const hiddenInRoot = root.querySelector('input[name="properties[Color]"]');
    if (hiddenInRoot) hiddenInRoot.value = color;

    const form = findForm(root);
    if (form) {
      let hf = form.querySelector('input[name="properties[Color]"]');
      if (!hf) {
        hf = document.createElement('input');
        hf.type = 'hidden';
        hf.name = 'properties[Color]';
        form.appendChild(hf);
      }
      hf.value = color;
    }
  };

  const setupShadows = (root) => {
    const container = root.querySelector('[data-ai-carousel]');
    const left = root.querySelector('[class*="ai-color-swatches__shadow-left"]');
    const right = root.querySelector('[class*="ai-color-swatches__shadow-right"]');
    if (!container || !left || !right) return;

    const update = () => {
      const max = container.scrollWidth - container.clientWidth;
      left.style.opacity = container.scrollLeft > 10 ? '1' : '0';
      right.style.opacity = container.scrollLeft < max - 10 ? '1' : '0';
    };
    container.addEventListener('scroll', update, { passive: true });
    setTimeout(update, 0);
  };

  /* ==== стрелки: клики по 1 карточке, без перепрыга края ==== */
  const setupNav = (root) => {
    const container = root.querySelector('[data-ai-carousel]');
    const btnL = root.querySelector('[class*="ai-nav-left-"]');
    const btnR = root.querySelector('[class*="ai-nav-right-"]');
    if (!container || !btnL || !btnR) return;

    const getPadLeft = () => parseFloat(getComputedStyle(container).paddingLeft) || 0;
    const starts = () => {
      const pad = getPadLeft();
      return Array.from(root.querySelectorAll('.ai-color-swatch')).map(el => el.offsetLeft - pad);
    };
    const clamp = (n, min, max) => Math.max(min, Math.min(n, max));

    const nearestIndex = (x) => {
      const s = starts();
      let best = 0, bestDiff = Infinity;
      for (let i = 0; i < s.length; i++) {
        const d = Math.abs(s[i] - x);
        if (d < bestDiff) { bestDiff = d; best = i; }
      }
      return best;
    };

    const maxScrollX = () => Math.max(0, container.scrollWidth - container.clientWidth);

    const scrollToIndex = (idx) => {
      const s = starts();
      idx = clamp(idx, 0, s.length - 1);
      container.scrollTo({ left: s[idx], behavior: 'smooth' });
    };

    const update = () => {
      const s = starts();
      const last = s.length ? s[s.length - 1] : 0;
      const noOverflow = maxScrollX() <= 0;
      const atStart = container.scrollLeft <= 0 + 1;
      const atEnd = container.scrollLeft >= last - 1;
      btnL.classList.toggle('is-disabled', noOverflow || atStart);
      btnR.classList.toggle('is-disabled', noOverflow || atEnd);
    };

    const click = (dir) => {
      const idx = nearestIndex(container.scrollLeft) + (dir > 0 ? 1 : -1);
      scrollToIndex(idx);
    };

    btnL.addEventListener('click', () => click(-1));
    btnR.addEventListener('click', () => click(1));
    container.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', () => { update(); });

    // в модалках размеры появляются после анимации — обновимся чуть позже
    requestAnimationFrame(() => requestAnimationFrame(update));
    setTimeout(update, 300);
  };

  const init = (root) => {
    if (!root || root.dataset.aiReady) return;
    root.dataset.aiReady = '1';

    selectFirst(root);
    setupShadows(root);
    setupNav(root);
  };

  // Инициализация уже существующих на странице
  document.querySelectorAll(ROOT).forEach(init);

  // Делегированный клик по свотчам
  document.addEventListener('click', (e) => {
    const swatch = e.target.closest('.ai-color-swatch');
    if (!swatch) return;
    const root = swatch.closest(ROOT);
    if (!root) return;

    root.querySelectorAll('.ai-color-swatch').forEach((s) => s.classList.remove('selected'));
    swatch.classList.add('selected');
    syncValue(root, swatch.getAttribute('data-color') || '');
  });

  // Авто-инициализация для динамически добавленных нод (quick-add, ajax и т.п.)
  const mo = new MutationObserver((muts) => {
    for (const m of muts) {
      for (const node of m.addedNodes) {
        if (node.nodeType !== 1) continue;
        if (node.matches?.(ROOT)) init(node);
        node.querySelectorAll?.(ROOT).forEach(init);
      }
    }
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
